import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const ItemFoundInfoStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  max-width: 100%;
  padding: ${theme.spacing.lg} ${theme.spacing.xl};

  svg {
    path {
      fill: ${theme.colors.neutral.high};
    }
  }

  #NoItemFoundTitle {
    text-align: center;
    font-family: ${theme.typography.family.bold};
    margin-top: ${theme.spacing.md};
    font-size: ${theme.typography.sizes['2md']};
    font-weight: ${theme.typography.weight.lg};
    margin-bottom: ${theme.spacing.xs};
    color: ${theme.colors.neutral.high};
  }

  #NoItemFoundDescription {
    text-align: center;
    font-size: ${theme.typography.sizes.sm};
    line-height: ${theme.typography.lineHeight.md};
    color: ${theme.colors.neutral.high};
  }
`
